// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"72bc336e","382":"96ccf018","666":"c0e1fecb","988":"139d08aa"}[chunkId] + ".chunk.js";
};